import { countRange } from "./model";
import { useObservatoryCopy } from "./copy";

export function ReportingTrendTable({
  rows,
}: {
  rows: Array<{ month: string; threat: string; lower: number; upper: number }>;
}) {
  const { t } = useObservatoryCopy();
  return (
    <div className="observatory-table-scroll">
      <table>
        <thead>
          <tr>
            <th>{t("period")}</th>
            <th>{t("threat")}</th>
            <th>{t("cases")}</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <tr key={`${row.month}-${row.threat}`}>
              <td>
                <bdi>{row.month}</bdi>
              </td>
              <td>{row.threat}</td>
              <td>
                <bdi>{countRange(row)}</bdi>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
